<template>
  <div class="footer flex-c-c font-smallest">
    <div class="footer-first flex-c-sb">
      <p>客服电话：4008689689</p>
      <p class="line-tap">|</p>
      <p>开发者/运营机构：炫彩互动网络科技有限公司</p>
      <p class="line-tap">|</p>
      <p>
        <a
          href="https://act.play.cn/hd/t/guide_detail/?content_id=5287&from=0&caf=2000001"
          target="_blank"
          rel="noopener noreferrer"
        >
          《云游戏用户协议》
        </a>
        <a
          href="https://act.play.cn/hd/t/guide_detail/?content_id=5254&from=0&caf=2000001"
          target="_blank"
          rel="noopener noreferrer"
        >
          《云游戏隐私政策》
        </a>
        <a
          href="https://act.play.cn/hd/t/guide_detail/?content_id=3540&from=0&caf=2000001"
          target="_blank"
          rel="noopener noreferrer"
        >
          《天翼云游戏应用权限》
        </a>
      </p>
    </div>
    <div class="footer-second flex-c-sb">
      <div>
        Copyright©2009-{{ currentYear }}炫彩互动网络科技有限公司版权所有
      </div>
      <div class="line-tap">|</div>
      <div>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          苏ICP备14019000号-1
        </a>

        <a
          href="https://ctcdn.cloud.play.cn/f/cloud/pkg/B2-20230728.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          [跨地区增值业务许可证B2-20140317]
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "footer",
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style lang="stylus">
.flex-c-sb
  layout-flex(center,space-between);
.flex-c-c
  layout-flex(center,center);
  flex-direction: column;
.font-smallest
  font-size: $font-size-extra-small;
  opacity: 0.8;
.footer
  position:absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  color: rgba(255,255,255,0.4) !important;
  z-index: 6;
  .line-tap
    margin: 0 20px;
  .footer-first,.footer-second
    margin: 5px;
    a
      color: rgba(255,255,255,0.4) !important;
      text-decoration: none;
</style>
